import React, { Component } from 'react';
import { Route, Switch, Link, Redirect } from 'react-router-dom'
import ReactLoading from "react-loading";
import * as Session from './session'

export class NotFound extends Component {

    constructor(props){
        super(props)
    }

    render(){
        return (
            <div>
                <div className="text-center">
                    <ErrorPanel userEmail={this.props.match.params.userEmail}/>
                    <br/><br/>
                    <Link to="/register" className="btn btn-primary">
                        Iniciar
                    </Link>
                    <br/><br/>
                    <p className="small text-muted text-center">
                        Para criar uma nova sessão
                    </p>
                </div>
            </div>
            
        )
    }
}

const ErrorPanel = (props) => (
    <div className="card mx-auto " style={{width: '40rem'}}>
        <div className="card-header alert-danger">
            Item não encontrado
        </div>
        <div>
            <p>
                <br/>
            </p>
            <p className="alert text-muted">
                Não foi encontrado o item relacionado com <code>{props.userEmail}</code>
            </p>
        </div>
        <div>
            <p>
                Por favor confirme que utilizou o endereço correcto
                <br/>
                Exemplo: <code className="text-primary">{window.location.host}/user/colaborador@empresa.pt</code>
            </p>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/NotFound.jsx